
export const isHtmlWithText = (__html = ''): string => {
    const regExp = /(<([^>]+)>)/ig;
    const html = __html.replace(regExp, '');
    return html;
};
